<template>
  <div class="actualWeather">
    <div class="actual-nav">
      <ul>
        <li :class="activeNav==='BJWeather'?'active':''" @click="handleActiveNav('BJWeather')">北京气温</li>
        <li :class="activeNav==='BJRain'?'active':''" @click="handleActiveNav('BJRain')">北京降水</li>
        <li :class="activeNav==='BJWind'?'active':''" @click="handleActiveNav('BJWind')">北京风速</li>
        <li :class="activeNav==='JJJRain'?'active5':''" @click="handleActiveNav('JJJRain')">京津冀降水</li>
      </ul>
    </div>
    <component :is="activeNav"></component>
  </div>
</template>
<script>
import BJWeather from '@/views/actualWeather/components/bj-weather'
import BJRain from '@/views/actualWeather/components/bj-rain'
import BJWind from '@/views/actualWeather/components/bj-wind'
import JJJRain from '@/views/actualWeather/components/jjj-rain'
export default {
  name: 'Actual',
  components: {
    BJWeather,
    BJRain,
    BJWind,
    JJJRain
  },
  data () {
    return {
      activeNav: 'BJWeather',
    }
  },
  methods: {
    handleActiveNav (nav) {
      this.activeNav = nav
    }
  }

}
</script>
<style lang="less" scoped>
.actualWeather {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(#ffffff, #e5f3ff);
  .actual-nav {
    padding-top: 6%;
    box-sizing: border-box;
    flex: 1;
    background: url("./imgs/actualnav.png") no-repeat;
    background-size: 100% 100%;
    ul {
      display: flex;
      justify-content: space-around;
    }
    li {
      width: 160px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 30px;
      color: #3a3a3a;
      &:nth-last-of-type(1) {
        width: 190px;
      }
    }
    .active {
      background: url("./imgs/4activeButton.png") no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
    }
    .active5 {
      background: url("./imgs/5activeButton.png") no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
    }
  }
}
</style>
